import React from "react";
import "./About.css";
import avatar from "../../img/avatar.png"; // your avatar image

function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <header className="about-hero">
        <h1>About Us</h1>
        <p>
          Building trust, one project at a time. Learn more about who we are,
          what we do, and why clients choose us.
        </p>
      </header>

      {/* Company Intro */}
      <section className="about-section">
        <h2>Who We Are</h2>
        <p>
          Aarcon Construction is a leading construction company with years of
          expertise in delivering high-quality residential, commercial, and
          industrial projects. Our commitment to innovation, safety, and
          sustainability has helped us establish a strong reputation in the
          industry.
        </p>
      </section>

      {/* Mission & Values */}
      <section className="about-values">
        <div className="value-card">
          <h3>🏗️ Our Mission</h3>
          <p>
            To deliver world-class construction services with integrity,
            innovation, and excellence—ensuring that every project exceeds
            client expectations.
          </p>
        </div>
        <div className="value-card">
          <h3>🌍 Our Vision</h3>
          <p>
            To be the most trusted and respected construction partner globally,
            shaping skylines and creating sustainable communities.
          </p>
        </div>
        <div className="value-card">
          <h3>🤝 Our Values</h3>
          <p>
            Integrity, commitment, safety, and customer satisfaction are at the
            heart of everything we do.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="about-team">
        <h2>Meet Our Team</h2>
        <div className="team-container">
          <div className="team-card">
            <img src={avatar} alt="Founder" />
            <h4>Rajeev Hegde</h4>
            <p>Founder & CEO</p>
            <p>rajeevhegde@aarrcon.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
